import {POPUP_GRADES, getPopupAttribute} from '@/config/popup'
import {PageSetting} from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    pageSettings: [],
    pageSettingDetail: null,
    loading: false,
    error: null,
    isLockExamSearch: false,
    isLockPublishResult: false,
    displaySetting: null
  },
  mutations: {
    setPageSettings(state, pageSettings) {
      state.pageSettings = pageSettings
    },
    setPageSettingDetail(state, pageSettingDetail) {
      state.pageSettingDetail = pageSettingDetail
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setError(state, error) {
      state.error = error
    },
    setDisplaySetting(state, displaySetting) {
      const grade1ShowResults = displaySetting.find(item => item.attribute === 'grade1-show-results')
      const grade1ShowEnrollment = displaySetting.find(item => item.attribute === 'grade1-show-enrollment')
      const grade1ShowAssessment = displaySetting.find(item => item.attribute === 'grade1-show-assessment')
      const grade6ShowResults = displaySetting.find(item => item.attribute === 'grade6-show-results')
      const grade6ShowEnrollment = displaySetting.find(item => item.attribute === 'grade6-show-enrollment')
      const grade6ShowAssessment = displaySetting.find(item => item.attribute === 'grade6-show-assessment')
      const grade10ShowResults = displaySetting.find(item => item.attribute === 'grade10-show-results')
      const grade10ShowEnrollment = displaySetting.find(item => item.attribute === 'grade10-show-enrollment')
      const grade10ShowAssessment = displaySetting.find(item => item.attribute === 'grade10-show-assessment')
      const grade10ShowAcademicResult = displaySetting.find(item => item.attribute === 'grade10-show-academic-result')
      const grade10ShowDirectAdmissionResult = displaySetting.find(item => item.attribute === 'grade10-show-direct-admission-result')
      const grade10ShowDirectAdmissionTQB = displaySetting.find(item => item.attribute === 'grade10-show-direct-admission-tqb')
      const grade10ShowCityResult = displaySetting.find(item => item.attribute === 'grade10-show-city-result')
      const banner = displaySetting.find(item => item.attribute === 'banner')
      const banners = ['banner-1', 'banner-6', 'banner-10'].reduce((result, attribute) => {
        const setting = displaySetting.find(item => item.attribute === attribute)
        if (setting) result[attribute] = setting.value
        return result
      }, {})
      const popup = displaySetting.find(item => item.attribute === 'popup')
      const popups = POPUP_GRADES.map(getPopupAttribute).reduce((result, attribute) => {
        const setting = displaySetting.find(item => item.attribute === attribute)
        if (setting) result[attribute] = setting.value
        return result
      }, {})
      const grade10ShowCV = displaySetting.find(item => item.attribute === 'grade10-show-cv')
      const grade6ShowCV = displaySetting.find(item => item.attribute === 'grade6-show-cv')
      state.displaySetting = {
        grade1: {
          showResults: grade1ShowResults?.value || 'false',
          showEnrollment: grade1ShowEnrollment?.value || 'false',
          showAssessment: grade1ShowAssessment?.value || 'false'
        },
        grade6: {
          showResults: grade6ShowResults?.value || 'false',
          showEnrollment: grade6ShowEnrollment?.value || 'false',
          showAssessment: grade6ShowAssessment?.value || 'false',
          showCV: grade6ShowCV?.value || 'false'
        },
        grade10: {
          showResults: grade10ShowResults?.value || 'false',
          showEnrollment: grade10ShowEnrollment?.value || 'false',
          showAssessment: grade10ShowAssessment?.value || 'false',
          showAcademicResult: grade10ShowAcademicResult?.value || 'false',
          showDirectAdmissionResult: grade10ShowDirectAdmissionResult?.value || 'false',
          showDirectAdmissionTQB: grade10ShowDirectAdmissionTQB?.value || 'false',
          showCityResult: grade10ShowCityResult?.value || 'false',
          showCV: grade10ShowCV?.value || 'false'
        },
        banner: banner?.value || '',
        banners,
        popup: popup?.value || null,
        popups
      }
    }
  },
  actions: {
    async fetchPageSettings({commit}, params) {
      try {
        commit('setLoading', true)
        const response = await PageSetting.fetch(params)
        commit('setPageSettings', response)
        commit('setError', null)
        return response
      } catch (error) {
        commit('setError', error.message)
      } finally {
        commit('setLoading', false)
      }
    },

    async fetchPageSettingDetail({commit}, params) {
      try {
        commit('setLoading', true)
        const response = await PageSetting.fetch(params)
        commit('setPageSettingDetail', response[0])
        commit('setError', null)
        return response[0]
      } catch (error) {
        commit('setError', error.message)
      } finally {
        commit('setLoading', false)
      }
    },
    async fetchDisplaySetting({commit}) {
      try {
        commit('setLoading', true)
        const response = await PageSetting.fetch()
        commit('setPageSettings', response)
        commit('setDisplaySetting', response)
      } catch (error) {
        commit('setError', error.message)
      } finally {
        commit('setLoading', false)
      }
    },

    async createPageSetting({commit, state}, data) {
      try {
        commit('setLoading', true)
        const res = await PageSetting.create(data)
        commit('setPageSettings', [...state.pageSettings, res])
        commit('setError', null)
        return res
      } catch (error) {
        commit('setError', error.message)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },

    async updatePageSetting({commit, state}, {id, data}) {
      try {
        commit('setLoading', true)
        const res = await PageSetting.update(id, data)
        commit(
          'setPageSettings',
          state.pageSettings.map(item => (item.id === id ? res : item))
        )
        commit('setError', null)
        return res
      } catch (error) {
        commit('setError', error.message)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },

    async deletePageSetting({commit, state}, id) {
      try {
        commit('setLoading', true)
        await PageSetting.remove(id)
        commit('setError', null)
        commit(
          'setPageSettings',
          state.pageSettings.filter(item => item.id !== id)
        )
      } catch (error) {
        commit('setError', error.message)
        throw error
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getDisplaySetting: state => state.displaySetting,
    getPageSettings: state => state.pageSettings,
    getPageSettingDetail: state => state.pageSettingDetail,
    isLoading: state => state.loading,
    hasError: state => state.error !== null,
    getError: state => state.error,
    getIsLockExamSearch: state => state.isLockExamSearch,
    getIsLockPublishResult: state => state.isLockPublishResult
  }
}
